import Loadable from 'react-loadable';
import Loading from 'System/views/loading.jsx';


const ModalMessageSend = Loadable({
	loader: () => import(/* webpackChunkName: "Modals" */ "./components/messagesidebar/ModalSend.jsx"),
	loading: Loading
});

let modals = {
	ModalMessageSend
}

export default modals;